import "bootstrap/dist/css/bootstrap.min.css";
import { onValue, ref } from "firebase/database";
import { useEffect, useState } from "react";
import { db } from "../Firebase";
import DetailedView from "./DetailedView";

const PendingApprovals = () => {
  const [registrations, setRegistrations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedFamily, setSelectedFamily] = useState(null);

  useEffect(() => {
    const regRef = ref(db, "registration");
    const unsubscribe = onValue(regRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        const pendingRegs = Object.entries(data)
          .map(([id, regData]) => ({ id, ...regData }))
          .filter(reg => !reg.meta?.status || reg.meta?.status === 'pending')
          .sort((a, b) => (b.meta?.createdAt || 0) - (a.meta?.createdAt || 0));
        setRegistrations(pendingRegs);
      } else {
        setRegistrations([]);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="container my-5 text-center">
        <div className="spinner-border text-warning" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3">Loading pending approvals...</p>
      </div>
    );
  }

  if (selectedFamily) {
    return (
      <div className="container my-4">
        <button 
          className="btn btn-outline-secondary mb-3"
          onClick={() => setSelectedFamily(null)}
        >
          ← Back to List
        </button>
        <DetailedView familyRow={selectedFamily} />
      </div>
    );
  }

  return (
    <div className="container my-4">
      <div className="card shadow">
        <div className="card-header bg-warning text-dark d-flex justify-content-between align-items-center">
          <h5 className="mb-0">⏳ Pending Approvals ({registrations.length})</h5>
        </div>
        <div className="card-body p-0">
          {registrations.length === 0 ? (
            <div className="text-center py-5">
              <h6 className="text-muted">No pending registrations found</h6>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Registration ID</th>
                    <th>Head Name</th>
                    <th>Mobile</th>
                    <th>State</th>
                    <th>City</th>
                    <th>Block</th>
                    <th>Mandir</th>
                    <th>Members</th>
                    <th>Registration Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {registrations.map((reg, index) => (
                    <tr key={reg.id}>
                      <td>{index + 1}</td>
                      <td>
                        <span className="badge bg-warning text-dark">{reg.id}</span>
                      </td>
                      <td>{reg.basic?.headName || '-'}</td>
                      <td>{reg.basic?.mobile || reg.meta?.contactNumber || '-'}</td>
                      <td>{reg.basic?.state || '-'}</td>
                      <td>{reg.basic?.city || '-'}</td>
                      <td>{reg.basic?.block || '-'}</td>
                      <td>{reg.basic?.Mandirtype || '-'}</td>
                      <td>
                        <span className="badge bg-info">
                          {Object.keys(reg.members || {}).length}
                        </span>
                      </td>
                      <td>
                        {reg.meta?.createdAt 
                          ? new Date(reg.meta.createdAt).toLocaleDateString()
                          : '-'
                        }
                      </td>
                      <td>
                        <button
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => setSelectedFamily(reg)}
                        >
                          View Details
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PendingApprovals;